/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModule_componentModule = {
    readonly title: string | null;
    readonly subtitle: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly linkData: {
            readonly path: string | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModuleItem_item">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModuleItemList_componentModule">;
    readonly " $refType": "HpRespLocationsModule_componentModule";
};
export type HpRespLocationsModule_componentModule$data = HpRespLocationsModule_componentModule;
export type HpRespLocationsModule_componentModule$key = {
    readonly " $data"?: HpRespLocationsModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModule_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespLocationsModule_componentModule",
  "type": "LocationsModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "subtitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespLocationsModuleItem_item",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "HpRespLocationsModuleItemList_componentModule",
      "args": null
    }
  ]
};
(node as any).hash = 'eb02db3e068bf0ffb353678e5649d0c0';
export default node;
